<template>
  <div>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/intensityLoc.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <b-button variant="dark" size="sm" @click="unsaveParameters('intensity-localization')">UnSave Results</b-button>
    <b-button variant="success" size="sm" @click="saveParameters('intensity-localization')">Save Results</b-button>
    <b-button variant="danger" size="sm" @click="flagParameters('intensity-localization')">Flag for Pipeline Expert</b-button>
    <b-button class="float-sm-right" variant="warning" size="sm" @click="badParameters('intensity-localization')">Bad Data</b-button>
    <div v-for="(round, index) in intensityLocalizationItems" :key="index" style="margin-top: 50px;">
      <h4> Last Processed on: {{ round['processedAt'] }}</h4>
      <b-row>
        <b-col md="8">
          <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['beamspec']}`"/>
        </b-col>
        <b-col md="4">
          <div style="margin-top: 80px">
            <table border="1">
              <tr align="left">
                <td> RA (deg): </td>
                <td v-for="n in round['fitData']['ra_list'].length" :key="n">
                    {{ round['fitData']['ra_list'][n-1] }} +/- {{ round['fitData']['ra_list_error'][n-1] }}
                </td>
              </tr>
              <tr align="left">
                <td> Dec (deg): </td>
                <td v-for="n in round['fitData']['dec_list'].length" :key="n">
                    {{ round['fitData']['dec_list'][n-1] }} +/- {{ round['fitData']['dec_list_error'][n-1] }}
                </td>
              </tr>
              <tr align="left">
                <td> x (deg): </td>
                <td v-for="n in round['fitData']['x_list'].length" :key="n">
                    {{ round['fitData']['x_list'][n-1] }} +/- {{ round['fitData']['x_list_error'][n-1] }}
                </td>
              </tr>
              <tr align="left">
                <td> y (deg): </td>
                <td v-for="n in round['fitData']['y_list'].length" :key="n">
                    {{ round['fitData']['y_list'][n-1] }} +/- {{ round['fitData']['y_list_error'][n-1] }}
                </td>
              </tr>
              <tr align="left">
                <td> Chi2 / DOF: </td>
                <td v-for="n in round['fitData']['ra_list'].length" :key="n">
                    {{ round['fitData']['chi2_list'][n-1] }} / {{ round['fitData']['dof'] }}
                </td>
              </tr>
            </table>
          </div>
          <div style="margin-top: 30px;text-align:left">
            <h5 text-align="left">Verification Checklist:</h5>
            <ol text-align="left">
              <li>Is there at least one well-contained region in the beam grid plot?</li>
              <li>Do the error bars contain those regions?</li>
              <li>Does the model (red dotted-line) match the data (black solid line) in the spectra plots?</li>
              <li>Are the residuals low (within +/- 1; i.e. the grey bar)?</li>
              <li>Are the Chi2 values close to the DOF (i.e. is the reduced chi2 ~1)?</li>
            </ol>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <details style="text-center">
          <summary>Show Corner Plot</summary>
          <b-row>
            <b-col md="8">
                <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['corner']}`"/>
            </b-col>
            <b-col md="4">
              <div style="margin-top: 80px">
                <table border="0">
                  <tr align="left">
                    <td> nchain start: </td>
                    <td> {{ round['fitData']['nchain_start'] }}</td>
                  </tr>
                  <tr align="left">
                    <td> nchain end: </td>
                    <td> {{ round['fitData']['nchain_end'] }}</td>
                  </tr>
                  <tr align="left">
                    <td> nwalkers start: </td>
                    <td> {{ round['fitData']['nwalkers_start'] }}</td>
                  </tr>
                  <tr align="left">
                    <td> nwalkers end: </td>
                    <td> {{ round['fitData']['nwalkers_end'] }}</td>
                  </tr>
                </table>
              </div>
            </b-col>
          </b-row>
        </details>
      </b-row>
    </div>
  </div>
</template>

<script>
export default{
  props: [
    'unsaveParameters',
    'saveParameters',
    'flagParameters',
    'badParameters',
    'intensityLocalizationItems'
  ]
}

</script>



// WEBPACK FOOTER //
// src/components/intensityLoc.vue